import type { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row, theme } from 'antd';
import { PosInput } from 'pos-client/components/shared/Form/PosInput.tsx';
import type { RMAssetFormType } from 'pos-shared/models/resourceManagementSchema.ts';

interface BasicDetailsProps {
  control: Control<RMAssetFormType>;
}

const BasicDetailsTabContent = ({ control }: BasicDetailsProps) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();

  return (
    <Row gutter={[token.marginXL, token.marginXL]}>
      <Col span={12}>
        <PosInput
          control={control}
          name="name"
          label={t('common.contact.name')}
          readOnly
        />
      </Col>
      <Col span={12}>
        <PosInput
          control={control}
          name="description"
          label={t('common.words.description')}
          readOnly
        />
      </Col>
    </Row>
  );
};

export default BasicDetailsTabContent;
